import { createReducer, on } from '@ngrx/store';
import * as CoreActions from './actions';
import { ICoreState, initialCoreState } from './state';

export const coreReducer = createReducer(
  initialCoreState,
  on(CoreActions.setTenantSlug, (state, { tenantSlug }): ICoreState => ({
    ...state,
    tenantSlug,
  })),
  on(CoreActions.loadAdministradoraAttempt, (state): ICoreState => ({
    ...state,
    administradoraError: null,
  })),
  on(CoreActions.loadAdministradoraSuccess, (state, { administradora }): ICoreState => ({
    ...state,
    administradora,
    administradoraLoaded: true,
    administradoraError: null,
  })),
  on(CoreActions.loadAdministradoraError, (state, { error }): ICoreState => ({
    ...state,
    administradoraLoaded: true,
    administradoraError: error,
  })),
  on(CoreActions.identificarAttempt, (state, { request }): ICoreState => ({
    ...state,
    identificacaoRequest: request,
    identificarError: null,
  })),
  on(CoreActions.identificarSuccess, (state, { response, tokenSessaoLogin }): ICoreState => ({
    ...state,
    loginEtapa: 'senha',
    iCodSegurado: response.iCodSegurado,
    tokenSessaoLogin,
  })),
  on(CoreActions.identificarError, (state, { error }): ICoreState => ({
    ...state,
    identificarError: error,
  })),
  on(CoreActions.loginAttempt, (state): ICoreState => ({
    ...state,
    loginError: null,
  })),
  on(CoreActions.loginError, (state, { error }): ICoreState => ({
    ...state,
    loginError: error,
  })),
  on(CoreActions.voltarIdentificacao, (state): ICoreState => ({
    ...state,
    loginEtapa: 'identificacao',
    loginError: null,
  })),
  on(CoreActions.setAuthData, (state, { user, token }): ICoreState => ({
    ...state,
    user,
    token,
    identificarError: null,
    loginError: null,
  })),
  on(CoreActions.signOut, (state): ICoreState => ({
    ...state,
    user: null,
    token: null,
    loginEtapa: 'identificacao',
    identificacaoRequest: null,
    iCodSegurado: null,
    tokenSessaoLogin: null,
    identificarError: null,
    loginError: null,
  })),
  on(CoreActions.toggleSidenav, (state): ICoreState => ({
    ...state,
    sidenavOpened: !state.sidenavOpened,
  })),
  on(CoreActions.setSidenavOpened, (state, { opened }): ICoreState => ({
    ...state,
    sidenavOpened: opened,
  }))
);
